import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../Components/Owl.css";

import Logo1 from "../Images/Partners/berkeley.jpg";
import Logo2 from "../Images/Partners/berkeley-air-logo-2.jpg";
import Logo3 from "../Images/Partners/KPMG_logo.jpg";
import Logo4 from "../Images/Partners/globalalliance.jpg";
import Logo5 from "../Images/Partners/Technology-Consults-Limited-Logo.jpg";
import Logo6 from "../Images/Partners/stanford.jpg";
import Logo7 from "../Images/Partners/Serc.jpg";
import Logo8 from "../Images/Partners/rebel.jpg";
import Logo9 from "../Images/Partners/giz.jpg";
import Logo10 from "../Images/Partners/worldbank.jpg";
import Logo11 from "../Images/Partners/wwf.jpg";
import Logo12 from "../Images/Partners/Envirofit International Ltd.jpg";
import Logo13 from "../Images/Partners/psfu.jpg";
import Logo14 from "../Images/Partners/Bank-of-Uganda.jpg";
import Logo15 from "../Images/Partners/bsul.jpg";
import Logo16 from "../Images/Partners/carbonclear.jpg";
import Logo17 from "../Images/Partners/CCA logo.jpg";
import Logo18 from "../Images/Partners/climate secure.jpg";
import Logo19 from "../Images/Partners/Co2.jpg";
import Logo20 from "../Images/Partners/dutchspark.jpg";
import Logo21 from "../Images/Partners/ecotrust.jpg";
import Logo22 from "../Images/Partners/Enabel.jpg";
import Logo23 from "../Images/Partners/finnfund.jpg";
import Logo24 from "../Images/Partners/ground-truth-solutions.jpg";
import Logo25 from "../Images/Partners/GVEP.jpg";
import Logo26 from "../Images/Partners/habitatforhumanity.jpg";
import Logo27 from "../Images/Partners/HIVOS.jpg";
import Logo28 from "../Images/Partners/idin.jpg";
import Logo29 from "../Images/Partners/UKaid.jpg";
import Logo30 from "../Images/Partners/impact-carbon.jpg";
import Logo31 from "../Images/Partners/ImpactWater.jpg";
import Logo32 from "../Images/Partners/kima foods.jpg";
import Logo33 from "../Images/Partners/living earth uganda.jpg";
import Logo34 from "../Images/Partners/loughborough-university-logo.jpg";
import Logo35 from "../Images/Partners/masupa_logo.jpg";
import Logo36 from "../Images/Partners/MECS.jpg";
import Logo37 from "../Images/Partners/memdlogofnl.jpg";
import Logo38 from "../Images/Partners/Myclimate.jpg";
import Logo39 from "../Images/Partners/ren21_logo.jpg";
import Logo40 from "../Images/Partners/snv.jpg";
import Logo41 from "../Images/Partners/spgs.jpg";
import Logo42 from "../Images/Partners/uganda-carbon-bureau.jpg";
import Logo43 from "../Images/Partners/undp.jpg";
import Logo44 from "../Images/Partners/unacc.jpg";
import Logo45 from "../Images/Partners/usaid.jpg";
import Logo46 from "../Images/Partners/UNREEEA.jpg";
import Logo47 from "../Images/Partners/upe.jpg";
import Logo48 from "../Images/Partners/SEI.jpg";
import Logo49 from "../Images/Partners/PELUM.jpg";

const PARTNERS = [
  {
    img: Logo1,
    href: "https://www.berkeley.edu/",
    alt: "University of California, Berkeley",
  },
  { img: Logo2, href: "https://berkeleyair.com/", alt: "Berkeley Air" },
  {
    img: Logo3,
    href: "https://kpmg.com/xx/en/home/about/offices/kampala-1.html",
    alt: "KPMG",
  },
  {
    img: Logo4,
    href: "https://cleancooking.org/",
    alt: "Global Alliance for Clean Cookstoves",
  },
  {
    img: Logo5,
    href: "http://www.teco.co.ug/",
    alt: "Technology Consults Limited",
  },
  { img: Logo6, href: "https://www.stanford.edu/", alt: "Stanford University" },
  {
    img: Logo7,
    href: "https://schatzcenter.org/",
    alt: "Schatz Energy Research Center",
  },
  { img: Logo8, href: "https://rebelgroup.com/en/", alt: "Rebel Group" },
  { img: Logo9, href: "https://www.giz.de/en/worldwide/310.html", alt: "GIZ" },
  { img: Logo10, href: "https://www.worldbank.org/en/home", alt: "World Bank" },
  { img: Logo11, href: "https://www.worldwildlife.org/", alt: "WWF" },
  {
    img: Logo12,
    href: "https://envirofit.org/",
    alt: "Envirofit International",
  },
  { img: Logo13, href: "https://www.psfuganda.org/", alt: "PSFU" },
  { img: Logo14, href: "https://www.bou.or.ug/", alt: "Bank of Uganda" },
  {
    img: Logo15,
    href: "https://www.biogassolutions.co.ug/",
    alt: "Biogas Solutions Uganda",
  },
  { img: Logo16, href: "https://www.carbonclear.earth/", alt: "Carbon Clear" },
  { img: Logo17, href: "https://cleancooking.org/", alt: "CCA" },
  {
    img: Logo18,
    href: "https://www.climate-secure.com/",
    alt: "Climate Secure",
  },
  { img: Logo19, href: "https://www.co2balance.com/", alt: "CO2 Balance" },
  { img: Logo20, href: "https://dutch-spark.org/", alt: "Dutch Spark" },
  { img: Logo21, href: "https://ecotrust.or.ug/", alt: "Ecotrust" },
  { img: Logo22, href: "https://www.enabel.be/", alt: "Enabel" },
  { img: Logo23, href: "https://www.finnfund.fi/en/", alt: "Finnfund" },
  {
    img: Logo24,
    href: "https://www.groundtruthsolutions.org/",
    alt: "Ground Truth Solutions",
  },
  { img: Logo25, href: "https://energy4impact.org/", alt: "Energy 4 Impact" },
  {
    img: Logo26,
    href: "https://habitat.ug/",
    alt: "Habitat for Humanity Uganda",
  },
  { img: Logo27, href: "https://hivos.org/", alt: "HIVOS" },
  { img: Logo28, href: "https://www.idin.org/", alt: "IDIN" },
  { img: Logo29, href: "https://www.ukaiddirect.org/", alt: "UK Aid" },
  { img: Logo30, href: "https://impactcarbon.org/", alt: "Impact Carbon" },
  { img: Logo31, href: "http://www.impactwater.co/", alt: "Impact Water" },
  { img: Logo32, href: "https://kiimafoods.com/", alt: "Kiima Foods" },
  {
    img: Logo33,
    href: "https://livingearthuganda.com/",
    alt: "Living Earth Uganda",
  },
  {
    img: Logo34,
    href: "https://www.lboro.ac.uk/",
    alt: "Loughborough University",
  },
  {
    img: Logo35,
    href: "https://seed.uno/enterprise-profiles/masupa-enterprises",
    alt: "Masupa Enterprises",
  },
  { img: Logo36, href: "https://mecs.org.uk/", alt: "MECS" },
  {
    img: Logo37,
    href: "https://memd.go.ug/",
    alt: "Ministry of Energy and Mineral Development",
  },
  { img: Logo38, href: "https://www.myclimate.org/en/", alt: "myclimate" },
  { img: Logo39, href: "https://www.ren21.net/", alt: "REN21" },
  { img: Logo40, href: "https://www.snv.org/", alt: "SNV" },
  { img: Logo41, href: "https://spgs.mwe.go.ug/", alt: "SPGS" },
  {
    img: Logo42,
    href: "http://www.ugandacarbon.org/",
    alt: "Uganda Carbon Bureau",
  },
  { img: Logo43, href: "https://www.undp.org/uganda", alt: "UNDP Uganda" },
  { img: Logo44, href: "https://www.unaccug.org/", alt: "UNACC" },
  { img: Logo45, href: "https://www.usaid.gov/", alt: "USAID" },
  { img: Logo46, href: "https://unreeea.org/", alt: "UNREEEA" },
  {
    img: Logo47,
    href: "https://www.upenergygroup.com/",
    alt: "UP Energy Group",
  },
  {
    img: Logo48,
    href: "https://www.sei.org/",
    alt: "Stockholm Environment Institute",
  },
  { img: Logo49, href: "https://pelumuganda.org/", alt: "PELUM Uganda" },
];

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 600,
  autoplay: true,
  autoplaySpeed: 2800,
  slidesToShow: 6,
  slidesToScroll: 1,
  cssEase: "ease-in-out",
  pauseOnHover: true,
  swipeToSlide: true,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 5 } },
    { breakpoint: 1024, settings: { slidesToShow: 4 } },
    { breakpoint: 768, settings: { slidesToShow: 3 } },
    { breakpoint: 600, settings: { slidesToShow: 2 } },
    { breakpoint: 360, settings: { slidesToShow: 2 } },
  ],
};

function Owl() {
  return (
    <div className="owl-carousel-wrapper">
      <Slider {...sliderSettings}>
        {PARTNERS.map((partner, index) => (
          /*
           * tabIndex={-1} on the wrapper fixes the Lighthouse
           * aria-hidden/focusable-descendants warning that react-slick
           * triggers on its cloned slides. The <a> inside is still
           * reachable on active slides; on hidden clones the wrapper
           * removes it from the tab order entirely.
           */
          <div key={index} tabIndex={-1} style={{ outline: "none" }}>
            <div className="owl-logo-card">
              <a
                href={partner.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={partner.alt}
              >
                <img
                  src={partner.img}
                  alt={partner.alt}
                  loading="lazy"
                  width="300"
                  height="113"
                />
              </a>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default Owl;
